import { Button } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const StyledUploadButton = styled(Button)`
  margin: 0 auto 8rem;
  min-width: 24rem;
`;
